import ClickAttacherService from '../ClickAttacherService';
import LocalEventNormalizer from '../helpers/LocalEventNormalizer';

export const clickAttacherServiceFactory = ddmDataLayerService => {
  const localEventNormalizer = new LocalEventNormalizer();

  return new ClickAttacherService(ddmDataLayerService, localEventNormalizer);
};
